import { BehaviorSubject } from 'rxjs';

import { handleResponse } from '../helpers';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

const BASE_URL = process.env.REACT_APP_API_URL;

export const authenticationService = {
    login,
    logout,

    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

function login(profile, tokenObj) {
    let user = {
        email: profile.email,
        token: tokenObj.id_token,
        expire: tokenObj.expires_at,
        imageUrl: profile.imageUrl
    };
    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': user.token
        },
        body: JSON.stringify(user)
    };
    return fetch(BASE_URL + '/auth', requestOptions)
        .then(handleResponse)
        .then(response => {
            // The backend derives the authoritative email from verified token
            // claims. Never persist the unverified profile email instead.
            user.email = response.email;
            // store user details and jwt token in local storage to keep user
            // logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);
        })
        .catch(err => console.log(err));
}

function logout() {
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
}
